import * as core from '../../../../../../../core'
import * as proposals from '../proposals'

export const RESOURCE = {
  payload: {
    alias: 'proposal.details',
    appAlias: proposals.RESOURCE.payload.alias,
    description: 'See and edit details of a proposal',
    display: {
      isMain: false,
      position: 0,
    },
    name: 'Proposal Details',
    page: { alias: 'proposal.details' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
